const CODE_VERIFIER_LENGTH = 32;

export async function generatePkceData(): Promise<[string, string]> {
  const array = new Uint8Array(CODE_VERIFIER_LENGTH);
  crypto.getRandomValues(array);
  const codeVerifier = base64UrlEncode(array);

  const encoder = new TextEncoder();
  const codeVerifierData = encoder.encode(codeVerifier);

  const hashData = new Uint8Array(await crypto.subtle.digest('SHA-256', codeVerifierData));

  return [codeVerifier, base64UrlEncode(hashData)];
}

export function base64UrlEncode(array: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < array.length; i++) {
    binary += String.fromCharCode(array[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
